/*=================================== 
				Config 
=======================================*/

/**
 * [Couleurs attribuées à :
 *  - différentes classes dans Gestion (Dernières connexions)
 *  - niveaux de différenciation (Questions / Donner / Différenciation)
 * ]
 * @type {Array}
 */
export const tab_color = [
    'rgba(0, 128, 128, 1)',//teal
    'rgba(210, 105, 30, 1)', //chocolate
    'rgba(128, 0, 128, 1)', //purple
    'rgba(0, 204, 0, 1)', //#00cc00
    'rgba(0, 0 , 255, 1)', //blue
    'rgba(255, 0, 0, 1)', //red
    'rgba(0, 128, 0, 1)',//green
    'rgba(128, 0, 0, 1)', //maroon
    'rgba(0, 0, 0, 1)',//black
  ]

export const tab_color_bg = tab_color.map(e => e.replace(', 1)', ', 0.05)'))
export const tab_color_btn = tab_color.map(e => e.replace(', 1)', ', 0.7)'))

export const niveaux = [
    {title:'6e', color:'rgba(0, 11, 172, 0.47)', h1:'Sixième',slug:'6e'},
    {title:'5e', color:'rgba(54, 0, 174, 0.58)', h1:'Cinquième',slug:'5e'},
    {title:'4e', color:'rgba(174, 82, 0, 0.58)', h1:'Quatrième',slug:'4e'},
    {title:'3e', color:'rgba(0, 138, 48, 0.7)', h1:'Troisième',slug:'3e'},
    {title:'2de', color:'rgb(80,130,180)', h1:'Seconde',slug:'2de'},
    {title:'2de Pro', color:'rgb(150,90,60)', h1:'Seconde Pro',slug:'2de_pro'},
    {title:'1re Pro', color:'rgb(120,70,50)', h1:'Première Pro',slug:'1re_pro'},
    {title:'Term Pro', color:'rgb(90,50,40)', h1:'Terminale Pro',slug:'term_pro'},
    {title:'Tronc.C. 1re G', color:'rgb(80,130,180)', h1:'Tronc commun de 1re G',slug:'tronc-com-1reG'},
    {title:'Spé 1re G', color:'rgb(200,80,100)', h1:'Spé 1re G',slug:'1re-G'},
    {title:'Voie tech.', color:'rgba(120, 150, 140, 1)', h1:'Voie technologique',slug:'voie-technologique'},
    {title:'Spé STI2D', color:'rgba(120, 150, 140, 1)', h1:'Spé STI2D',slug:'spe-STI2D'},
    {title:'Spé Term G', color:'rgb(200,80,100)', h1:'Spé Terminale G',slug:'term-G'},
    {title:'Maths comp.', color:'rgb(160,70,160)', h1:'Maths complémentaires',slug:'maths-complementaires'},
    {title:'Maths exp.', color:'rgb(160,70,160)', h1:'Maths expertes',slug:'maths-expertes'},
    {title:'Pour la phys.', color:'rgb(56,140,158)', h1:'Physique',slug:'physique'},
    {title:'BTS', color:'rgb(230,120,70)', h1:'BTS',slug:'BTS'},
    {title:'Prépa', color:'rgb(230,120,70)', h1:'Prépa',slug:'prepa'},
    {title:'Notice', color:'#314159', h1:'Notice',slug:'notice'},
    {title:'Vidéo', color:'#314159', h1:'Vidéo',slug:'video'},
    {title:'PPO', color:'#191970', h1:'PPO',slug:'PPO'},
  ]

/**
 * Couleurs des niveaux dans la page accueil Automaths
 * @type {Array}
 */
export const niv_color = [
    'rgba(0, 11, 172, 0.47)', // niveau 6e
    'rgba(54, 0, 174, 0.58)', // niveau 5e
    'rgba(174, 82, 0, 0.58)', // niveau 4e
    'rgba(0, 138, 48, 0.7)', // niveau 3e
    'rgb(80,130,180)', 
    'rgb(80,130,180)', 
    'rgb(200,80,100)', 
    'rgba(120, 150, 140, 1)', 
    'rgba(120, 150, 140, 1)', 
    'rgb(200,80,100)', 
    'rgb(160,70,160)', 
    'rgb(160,70,160)', 
    'rgb(56,140,158)', 
    'rgb(230,120,70)'
  ]
export const diff_color = ['teal', 'chocolate', 'purple']

export const title_college=['6e', '5e', '4e', '3e', '2de']
export const title_college_h1=['Sixième', 'Cinquième', 'Quatrième', 'Troisième', 'Seconde']
export const title_lycee=[
    'Tronc commun 1re G', 
    'Spé 1re G', 
    'Voie technologique', 
    'Spé STI2D', 
    'Spé Term G', 
    'Maths complémentaires', 
    'Maths expertes', 
    'Pour la physique', 
    'Prépa'
]
export const title_lycee_h1=['Tronc commun de 1re G', 'Spé 1re G', 'Voie technologique', 'Spé STI2D', 'Spé Terminale G', 'Maths complémentaires', 'Maths expertes', 'physique', 'Prépa']
export const slug_lycee=['tronc-com-1reG', '1re-G', 'voie-technologique', 'spe-STI2D', 'term-G', 'maths-complementaires', 'maths-expertes', 'physique', 'prepa']

const sur_themes_color = {
    'Nombres_calculs':'#eeeca0',
    'Grandeurs':'#d5d69a',
    'Geometrie':'#a6c2d5',
    'Algorithme':'#d1ecee',
    'Fonctions':'#c3deb3',
    'Statistiques':'#ebc6ad',
    'Complexes':'#fbbf00',
    'Automatismes':'#f0e474',
    'Autre':'#61bf61',
}
export const sur_themes = [
      {niveau:'6e', pos:0, theme:'Nombres et calculs', color:sur_themes_color.Nombres_calculs},
      {niveau:'6e', pos:4, theme:'Organisation et gestion de données et probabilités', color:sur_themes_color.Fonctions},
      {niveau:'6e', pos:6, theme:'Grandeurs et mesures', color:sur_themes_color.Grandeurs},
      {niveau:'6e', pos:11, theme:'Espace et géométrie', color:sur_themes_color.Geometrie},
      {niveau:'5e', pos:0, theme:'Nombres et calculs', color:sur_themes_color.Nombres_calculs},
      {niveau:'5e', pos:6, theme:'Organisation et gestion de données, fonctions', color:sur_themes_color.Fonctions},
      {niveau:'5e', pos:10, theme:'Grandeurs et mesures', color:sur_themes_color.Grandeurs},
      {niveau:'5e', pos:15, theme:'Espace et géométrie', color:sur_themes_color.Geometrie},
      {niveau:'5e', pos:20, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'4e', pos:0, theme:'Nombres et calculs', color:sur_themes_color.Nombres_calculs},
      {niveau:'4e', pos:6, theme:'Organisation et gestion de données, fonctions', color:sur_themes_color.Fonctions},
      {niveau:'4e', pos:10, theme:'Grandeurs et mesures', color:sur_themes_color.Grandeurs},
      {niveau:'4e', pos:13, theme:'Espace et géométrie', color:sur_themes_color.Geometrie},
      {niveau:'4e', pos:20, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'3e', pos:0, theme:'Nombres et calculs', color:sur_themes_color.Nombres_calculs},
      {niveau:'3e', pos:5, theme:'Organisation et gestion de données, fonctions', color:sur_themes_color.Fonctions},
      {niveau:'3e', pos:10, theme:'Grandeurs et mesures', color:sur_themes_color.Grandeurs},
      {niveau:'3e', pos:12, theme:'Espace et géométrie', color:sur_themes_color.Geometrie},
      {niveau:'3e', pos:18, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'3e', pos:20, theme:'Le jour du Brevet', color:sur_themes_color.Automatismes},
      {niveau:'2de', pos:0, theme:'Automatismes', color:sur_themes_color.Automatismes},
      {niveau:'2de', pos:7, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'2de', pos:9, theme:'Nombres et calculs, algèbre', color:sur_themes_color.Nombres_calculs},
      {niveau:'2de', pos:8, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'2de', pos:14, theme:'Fonctions', color:sur_themes_color.Fonctions},
      {niveau:'2de', pos:17, theme:'Statistiques et probabilités', color:sur_themes_color.Statistiques},
      {niveau:'2de', pos:22, theme:'Géométrie', color:sur_themes_color.Geometrie},
      {niveau:'2de_pro', pos:0, theme:'Automatismes', color:sur_themes_color.Automatismes},
      {niveau:'2de_pro', pos:1, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'2de_pro', pos:2, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'2de_pro', pos:3, theme:'Statistiques et probabilités', color:sur_themes_color.Statistiques},
      {niveau:'2de_pro', pos:5, theme:'Algèbre – Analyse', color:sur_themes_color.Fonctions},
      {niveau:'2de_pro', pos:8, theme:'Géométrie', color:sur_themes_color.Geometrie},
      {niveau:'1re_pro', pos:0, theme:'Automatismes', color:sur_themes_color.Automatismes},
      {niveau:'1re_pro', pos:2, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'1re_pro', pos:1, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'1re_pro', pos:3, theme:'Statistiques et probabilités', color:sur_themes_color.Statistiques},
      {niveau:'1re_pro', pos:5, theme:'Algèbre – Analyse', color:sur_themes_color.Fonctions},
      {niveau:'1re_pro', pos:10, theme:'Géométrie', color:sur_themes_color.Geometrie},
      {niveau:'term_pro', pos:0, theme:'Automatismes', color:sur_themes_color.Automatismes},
      {niveau:'term_pro', pos:1, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'term_pro', pos:2, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'term_pro', pos:3, theme:'Statistiques et probabilités', color:sur_themes_color.Statistiques},
      {niveau:'term_pro', pos:5, theme:'Algèbre – Analyse', color:sur_themes_color.Fonctions},
      {niveau:'term_pro', pos:10, theme:'Géométrie', color:sur_themes_color.Geometrie},
      {niveau:'term_pro', pos:12, theme:'Programme complémentaire', color:sur_themes_color.Autre},
      {niveau:'tronc-com-1reG', pos:0, theme:'Automatismes', color:sur_themes_color.Automatismes},
      {niveau:'tronc-com-1reG', pos:7, theme:'Analyse de l\'information chiffrée', color:sur_themes_color.Statistiques},
      {niveau:'tronc-com-1reG', pos:8, theme:'Phénomènes aléatoires', color:sur_themes_color.Statistiques},
      {niveau:'tronc-com-1reG', pos:9, theme:'Phénomènes d\'évolution, modélisation par des fonctions', color:sur_themes_color.Fonctions},
      //{niveau:'tronc-com-1reG', pos:9, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'1re-G', pos:0, theme:'Automatismes', color:sur_themes_color.Automatismes},
      {niveau:'1re-G', pos:7, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'1re-G', pos:8, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'1re-G', pos:9, theme:'Analyse', color:sur_themes_color.Fonctions},
      {niveau:'1re-G', pos:12, theme:'Algèbre ', color:sur_themes_color.Fonctions},
      {niveau:'1re-G', pos:14, theme:'Probabilités et statistiques', color:sur_themes_color.Statistiques},
      {niveau:'1re-G', pos:16, theme:'Géométrie', color:sur_themes_color.Geometrie},
      {niveau:'term-G', pos:1, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'term-G', pos:2, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'term-G', pos:3, theme:'Algèbre et géométrie', color:sur_themes_color.Geometrie},
      {niveau:'term-G', pos:8, theme:'Analyse', color:sur_themes_color.Fonctions},
      {niveau:'term-G', pos:17, theme:'Probabilités', color:sur_themes_color.Statistiques},
      {niveau:'maths-complementaires', pos:1, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'maths-complementaires', pos:2, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'maths-complementaires', pos:3, theme:'Analyse', color:sur_themes_color.Fonctions},
      {niveau:'maths-complementaires', pos:11, theme:'Probabilités et statistique', color:sur_themes_color.Statistiques},
      {niveau:'voie-technologique', pos:0, theme:'Automatismes', color:sur_themes_color.Automatismes},
      {niveau:'voie-technologique', pos:7, theme:'Algorithme et programmation', color:sur_themes_color.Algorithme},
      {niveau:'voie-technologique', pos:8, theme:'Vocabulaire ensembliste et logique', color:sur_themes_color.Grandeurs},
      {niveau:'voie-technologique', pos:9, theme:'Statistiques et probabilités', color:sur_themes_color.Statistiques},
      {niveau:'voie-technologique', pos:12, theme:'Analyse', color:sur_themes_color.Fonctions},
      {niveau:'spe-STI2D', pos:0, theme:'Géométrie dans le plan ', color:sur_themes_color.Geometrie},
      {niveau:'spe-STI2D', pos:2, theme:'Analyse', color:sur_themes_color.Fonctions},
      {niveau:'spe-STI2D', pos:8, theme:'Nombres complexes ', color:sur_themes_color.Complexes},
      {niveau:'maths-expertes', pos:0, theme:'Nombres complexes ', color:sur_themes_color.Complexes},
      {niveau:'maths-expertes', pos:5, theme:'Arithmétique ', color:sur_themes_color.Geometrie},
      {niveau:'maths-expertes', pos:9, theme:'Graphes et matrices ', color:sur_themes_color.Fonctions},
      {niveau:'BTS', pos:0, theme:'Analyse', color:sur_themes_color.Fonctions},
      {niveau:'BTS', pos:6, theme:'Statistiques et probabilités', color:sur_themes_color.Statistiques},
      {niveau:'BTS', pos:10, theme:'Algèbre et géométrie', color:sur_themes_color.Geometrie},
      {niveau:'physique', pos:14, theme:'Promenade des planètes d\'Orléans', color:sur_themes_color.Nombres_calculs},
    ]


export const users_fictifs = [
        {nom:'ROUMADNI', prenom:'Ab', profil:'Professeur', classe:'5e2, 3e3, 3e2, 6e5'},
        {nom:'TATOUILLE', prenom:'Lara', profil:'Eleve', classe:'5e2'},
        {nom:'AMANZOU', prenom:'El Hassan', profil:'Professeur', classe:'5e2, 3e3, 3e2, 6e5'},
        {nom:'GATOR', prenom:'Ali', profil:'Eleve', classe:'5e2'},
        {nom:'TOUILLE', prenom:'Sacha', profil:'Autre', classe:'5e2'},
        {nom:'STIQUET', prenom:'Sophie', profil:'Eleve', classe:'5e2'},
        {nom:'CURE', prenom:'Manu', profil:'Eleve', classe:'5e2'},
        {nom:'TEST', prenom:'Machin', profil:'Eleve', classe:'5e2'},
        {nom:'COPTAIR', prenom:'Elie', profil:'Eleve', classe:'5e2'},
        {nom:'SAGLICE', prenom:'Alice', profil:'Autre', classe:'5e2'},
        {nom:'UNPOINT', prenom:'Marc', profil:'Eleve', classe:'5e2'},
        {nom:'YARIVET', prenom:'Eva', profil:'Eleve', classe:'5e2'},
        {nom:'YARIVET', prenom:'Eva', profil:'Eleve', classe:'5e2'},
        {nom:'YARIVET', prenom:'Eva', profil:'Eleve', classe:'5e2'},
    ]


export function Config () {

  return (
    <div>
    	Configuration
    </div>
  );
}